//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'index-tab-permission',
  data: function data() {
    return {
      value: "<p>\n<a href=\"https://github.com/d2-projects/d2-admin\" target=\"_blank\" class=\"ql-size-large\" style=\"color: rgb(65, 184, 131);\"><strong>D2 Admin</strong></a>\n<strong style=\"color: rgb(65, 184, 131);\"></strong>\nby\n<a href=\"https://cn.vuejs.org/\" target=\"_blank\" class=\"ql-size-large\" style=\"color: rgb(65, 184, 131);\"><strong>vue.js</strong></a>\n</p>"
    };
  }
};